import { ConfirmationDialog } from '../Dialogs/ConfirmationDialog';
import { EditorialType, Node } from '../../domain/domain';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { ComponentManagementActionType } from '../../reducers/comp.actions';

type Props = {
    onRejectEditorialContent: (node: Node, editorialType: EditorialType) => void
}

const RejectEditorialContentDialog: React.FC<Props> = ({onRejectEditorialContent}) => {

    const open = useSelector((app: ApplicationState) => app.comp.rejectEdiorialContentDialogOpen);
    const selectedEditorialType = useSelector((app: ApplicationState) => app.comp.selectedEditorialType);
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const dispatch = useDispatch();

    if (!editorNode) {
        return <></>
    }

    return (
        <ConfirmationDialog
            open={open}
            title="Reject Editorial Content"
            contentText="Are you sure you want to reject changes to the editorial content for the current component?"
            handleNo={() => {
                dispatch({ type: ComponentManagementActionType.REJECT_EDITORIAL_CONTENT_DIALOG_OPEN, open: false });

            }}
            handleYes={() => {
                if (selectedEditorialType) {
                    onRejectEditorialContent(editorNode, selectedEditorialType);
                    dispatch({ type: ComponentManagementActionType.REJECT_EDITORIAL_CONTENT_DIALOG_OPEN, open: false });
                }
            }}
        />
    )
}

export default RejectEditorialContentDialog;